var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _vm.searchable
        ? _c(
            "v-card-title",
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c("v-text-field", {
                staticClass: "data-table-search",
                attrs: {
                  value: _vm.searchFromStore,
                  "append-icon": "search",
                  label: _vm.$t("Search"),
                  placeholder: _vm.$t("Search"),
                  "single-line": "",
                  "hide-details": ""
                },
                on: { input: _vm.updateSearchInStore }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("v-data-table", {
        attrs: {
          headers: _vm.headers,
          items: _vm.getItems,
          search: _vm.searchFromStore,
          loading: _vm.loading,
          "loading-text": "",
          "items-per-page-text": _vm.rowsPerPageText,
          "items-per-page-items": _vm.rowsPerPageItems,
          "header-props": { sortIcon: _vm.sortIcon },
          "footer-props": {
            prevIcon: _vm.prevIcon,
            nextIcon: _vm.nextIcon,
            "items-per-page-options": _vm.rowsPerPageItems
          },
          page: _vm.pagination.page,
          "items-per-page": _vm.paginationListItem.rowsPerPage
        },
        on: {
          "update:page": function($event) {
            return _vm.$set(_vm.pagination, "page", $event)
          },
          "update:itemsPerPage": function($event) {
            return _vm.$set(_vm.paginationListItem, "rowsPerPage", $event)
          },
          "update:items-per-page": function($event) {
            return _vm.$set(_vm.paginationListItem, "rowsPerPage", $event)
          },
          pagination: function($event) {
            return _vm.setRowsOnLocalStorage(
              _vm.dataTableListItemId,
              _vm.paginationListItem.rowsPerPage
            )
          }
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function(props) {
              return [
                _c("tr", [
                  _c("td", [_vm._v(_vm._s(props.item.code))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(props.item.libelle))]),
                  _vm._v(" "),
                  !_vm.isCustomList
                    ? _c("td", [_vm._v(_vm._s(props.item.client_code))])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isCustomList
                    ? _c("td", [_vm._v(_vm._s(props.item.client_label))])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isCustomList
                    ? _c(
                        "td",
                        [
                          !props.item.blocked
                            ? _c(
                                "v-layout",
                                { attrs: { row: "", "align-center": "" } },
                                [
                                  _c("div", {
                                    staticClass: "company-status-icon mr-3"
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "text-transform": "lowercase"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.$t("No")) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _c(
                                "v-layout",
                                { attrs: { row: "", "align-center": "" } },
                                [
                                  _c("div", {
                                    staticClass:
                                      "company-status-icon status-inactive mr-3"
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "text-transform": "lowercase"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.$t("Yes")) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                ]
                              )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isCustomList
                    ? _c(
                        "td",
                        [
                          !props.item.deleted
                            ? _c(
                                "v-layout",
                                { attrs: { row: "", "align-center": "" } },
                                [
                                  _c("div", {
                                    staticClass: "company-status-icon mr-3"
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "text-transform": "lowercase"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.$t("No")) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _c(
                                "v-layout",
                                { attrs: { row: "", "align-center": "" } },
                                [
                                  _c("div", {
                                    staticClass:
                                      "company-status-icon status-inactive mr-3"
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "text-transform": "lowercase"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.$t("Yes")) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                ]
                              )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isCustomList
                    ? _c("td", [_vm._v(_vm._s(props.item.definition))])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(props.item.index))]),
                  _vm._v(" "),
                  _c(
                    "td",
                    [
                      _c("app-datatable-action-buttons", {
                        attrs: {
                          "user-can-edit":
                            _vm.isSuperAdmin ||
                            (_vm.userHasManagementPermission(
                              "list_item",
                              "update"
                            ) &&
                              _vm.isAdmin &&
                              !_vm.isCustomList),
                          "user-can-delete": _vm.isCustomList
                            ? true
                            : !props.item.blocked
                        },
                        on: {
                          edit: function($event) {
                            return _vm.editItem(props.item)
                          },
                          delete: function($event) {
                            return _vm.askConfirmationToDeleteItem(props.item)
                          }
                        }
                      })
                    ],
                    1
                  )
                ])
              ]
            }
          },
          {
            key: "pageText",
            fn: function(props) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(props.pageStart) +
                    " - " +
                    _vm._s(props.pageStop) +
                    " " +
                    _vm._s(_vm.$t("tables.Of")) +
                    "\n      " +
                    _vm._s(props.itemsLength) +
                    "\n    "
                )
              ]
            }
          },
          {
            key: "no-results",
            fn: function() {
              return [
                _c("data-table-no-results", {
                  attrs: { search: _vm.searchFromParent }
                })
              ]
            },
            proxy: true
          },
          {
            key: "no-data",
            fn: function() {
              return [_vm.loading ? _c("div") : _vm._e()]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c("app-dialog-box", {
        attrs: {
          open: _vm.deleteDialog,
          title: _vm.$t("DeleteItem"),
          content:
            _vm.$t("DeleteConfirmation") +
            " " +
            (_vm.itemToDelete.client_label
              ? _vm.itemToDelete.client_label
              : _vm.itemToDelete.libelle + "?"),
          "main-action-label": _vm.$t("No"),
          "secondary-action-label": _vm.$t("Yes"),
          loading: _vm.loadingDelete
        },
        on: { mainAction: _vm.cancelDelete, secondaryAction: _vm.deleteItem }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-51832aa6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51832aa6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SystemManagement/SystemSettings/ListsSettings/ListItemTable.vue
// module id = null
// module chunks = 